import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=bb17c8a8&scoped=true"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"
import style0 from "./registration.vue?vue&type=style&index=0&id=bb17c8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb17c8a8",
  null
  
)

export default component.exports